import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Login } from "./login";
import { SignUp } from "./signup";
import { Verify } from "./verify";
import { Forgot } from "./forgot";
import { ResetPassword } from "./resetPassword"
export const AuthModal = ({ isOpen, onClose }) => {
  const [active, setActive] = useState("LOGIN");
  const [email, setEmail] = useState("");
  var [isForgot, setForgot] = useState(false);
  // console.log("forgot", isForgot)
  // console.log("forgot", active)
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          p: 4,
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            position: "relative",
            height: "560px",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              transition: "0.5s ease-in-out",
              width: "100%",
              transform: active === "LOGIN" ? "scale(1)" : "scale(0)",
            }}
          >
            <Login setActive={setActive} onClose={onClose} setForgot={setForgot} />
            {/* {isForgot ? <Login  setActive={() => setActive("FORGOT")} onClose={onClose} setForgot={setForgot}/>:<Login  setActive={() => setActive("SIGNUP")} onClose={onClose} setForgot={setForgot}/>} */}
          </Box>
          <Box
            sx={{
              position: "absolute",
              transition: "0.5s ease-in-out",
              width: "100%",
              transform: active === "VERIFY" ? "scale(1)" : "scale(0)",
            }}
          >
            <Verify setActive={() => setActive("LOGIN")} userEmail={email} />
          </Box>

          <Box
            sx={{
              position: "absolute",
              transition: "0.5s ease-in-out",
              width: "100%",
              transform: active === "SIGNUP" ? "scale(1)" : "scale(0)",
            }}
          >
            <SignUp setActive={() => setActive("VERIFY")} setEmail={setEmail} />
          </Box>
          <Box
            sx={{
              position: "absolute",
              transition: "0.5s ease-in-out",
              width: "100%",
              transform: active === "FORGOT" ? "scale(1)" : "scale(0)",
            }}
          >
            <Forgot setActive={() => setActive("RESET")} />
          </Box>

          <Box
            sx={{
              position: "absolute",
              transition: "0.5s ease-in-out",
              width: "100%",
              transform: active === "RESET" ? "scale(1)" : "scale(0)",
            }}
          >
            <ResetPassword setActive={() => setActive("LOGIN")} />
          </Box>

        </Box>
      </Box>
    </Modal>
  );
};
